import { render } from "./PerformanceManagement.vue?vue&type=template&id=2d92da29&scoped=true"
import script from "./PerformanceManagement.vue?vue&type=script&lang=js"
export * from "./PerformanceManagement.vue?vue&type=script&lang=js"

import "./PerformanceManagement.vue?vue&type=style&index=0&id=2d92da29&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d92da29"]])

export default __exports__